import { IconButton } from "@mui/material";
import { MouseEventHandler } from "react";
import { EditOutlined } from "@mui/icons-material";

export interface Props {
  editClicked: MouseEventHandler<HTMLButtonElement>;
}

export default function EditAciton({ editClicked }: Props) {
  return <IconButton onClick={editClicked}>
    <EditOutlined />
  </IconButton>;
}